import { render, staticRenderFns } from "./Held.vue?vue&type=template&id=a8bcab58"
import script from "./Held.vue?vue&type=script&lang=js"
export * from "./Held.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports